import { render, staticRenderFns } from "./MyApprovalPV.vue?vue&type=template&id=5ac765c2&scoped=true&lang=pug"
import script from "./MyApprovalPV.vue?vue&type=script&lang=js"
export * from "./MyApprovalPV.vue?vue&type=script&lang=js"
import style0 from "./MyApprovalPV.vue?vue&type=style&index=0&id=5ac765c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac765c2",
  null
  
)

export default component.exports